import { useContext, useMemo } from '@bpmn-io/properties-panel/preact/hooks';
import { LayoutContext } from '../context/LayoutContext';

export const useIsGroupOpen = (groupId: string): boolean => {
    const ctx = useContext(LayoutContext);
    return useMemo<boolean>(
        () => ctx.getLayoutForKey(['groups', groupId, 'open'], false),
        [groupId, ctx.layout]
    );
};
